/**
 * Style-aware PDP gallery filter for Rowan.
 * When a Style option is selected, hide product media/thumbnails whose alt
 * does not include the selected style value (e.g. "Leaning" / "Vertical Hold").
 * Featured-media swap still handled by Dawn; this only cleans mixed thumbs.
 */
(function () {
  function selectedStyle() {
    const checked = document.querySelector(
      'variant-selects input[type=radio][name="Style"]:checked, fieldset input[type=radio][name="Style"]:checked, input[type=radio][name="Style"]:checked'
    );
    if (checked && checked.value) return checked.value.trim();
    const select = document.querySelector('variant-selects select[name="options[Style]"], select[name="options[Style]"]');
    if (select && select.value) return select.value.trim();
    // Fallback: URL variant + product JSON
    try {
      const id = new URL(location.href).searchParams.get('variant');
      const json = window.ProductJson || window.meta?.product;
      // parse from product form dataset if present
    } catch (e) {}
    return null;
  }

  function applyFilter(style) {
    if (!style) return;
    const needles = [style];
    // Also accept compact forms
    if (/vertical/i.test(style)) needles.push('Vertical Hold', 'Vertical');
    if (/lean/i.test(style)) needles.push('Leaning', 'Lean');

    const nodes = document.querySelectorAll(
      'media-gallery .product__media-item, media-gallery .thumbnail-list__item, media-gallery button.thumbnail, .thumbnail-list li, .product__media-list .product__media-item'
    );
    let shown = 0;
    nodes.forEach((el) => {
      const img = el.querySelector('img') || (el.tagName === 'IMG' ? el : null);
      const alt = (img && (img.alt || img.getAttribute('alt'))) || el.getAttribute('aria-label') || '';
      // Only filter items that clearly belong to a Style via alt
      const tagged = /Leaning|Vertical Hold/i.test(alt);
      if (!tagged) return; // leave untagged (shared) media alone
      const match = needles.some((n) => alt.toLowerCase().includes(n.toLowerCase()));
      if (match) {
        el.style.display = '';
        el.removeAttribute('hidden');
        el.classList.remove('rowan-style-hidden');
        shown++;
      } else {
        el.style.display = 'none';
        el.setAttribute('hidden', 'hidden');
        el.classList.add('rowan-style-hidden');
      }
    });
    // If somehow nothing shown, unhide to avoid empty gallery
    if (shown === 0) {
      document.querySelectorAll('.rowan-style-hidden').forEach((el) => {
        el.style.display = '';
        el.removeAttribute('hidden');
        el.classList.remove('rowan-style-hidden');
      });
    }
  }

  function refresh() {
    applyFilter(selectedStyle());
  }

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t) return;
    if ((t.name === 'Style' || (t.name || '').includes('Style')) && (t.type === 'radio' || t.tagName === 'SELECT')) {
      touched = true;
      // allow Dawn to swap featured first
      setTimeout(refresh, 50);
      setTimeout(refresh, 300);
    }
  });
  // Rowan 2026-10-14 (v2): Vertical Hold is the default and its photos lead,
  // so filter the gallery to the selected Style on plain page load too.
  let touched = true;
  function loadRefresh() { if (touched) refresh(); }
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t && t.closest && t.closest('variant-radios, variant-selects')) {
      touched = true;
      setTimeout(refresh, 50);
      setTimeout(refresh, 300);
    }
  }, true);
  document.addEventListener('DOMContentLoaded', loadRefresh);
  document.addEventListener('variant:change', loadRefresh);
  setTimeout(loadRefresh, 100);
  setTimeout(loadRefresh, 800);
})();
